import "regenerator-runtime";
import { t } from "i18next";
import { discreteDescriptions } from "../helpers/enums";
import { Box, Slider, Typography } from "@mui/material";

export default function TwoDimSlider({
  value,
  disabled,
  onChange,
  title,
  firstItem = false,
  shortVersion = false,
}) {
  const marks = [
    {
      value: 0,
      label: "1",
    },
    {
      value: 1,
      label: "2",
    },
    {
      value: 2,
      label: "3",
    },
    {
      value: 3,
      label: "4",
    },
    {
      value: 4,
      label: "5",
    },
  ];

  const shortVersionMarks = [
    {
      value: 0,
      label: "1",
    },
    {
      value: 25,
      label: "2",
    },
    {
      value: 50,
      label: "3",
    },
    {
      value: 75,
      label: "4",
    },
    {
      value: 100,
      label: "5",
    },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        ml: firstItem ? 0 : 3,
        mb: 1.5,
      }}
    >
      <Typography sx={{ fontSize: 12.5, userSelect: "none" }}>
        {title}
      </Typography>
      <Slider
        size="small"
        sx={{
          ml: 1,
          mb: 0,
          mt: -0.5,
          width: { xs: shortVersion ? 100 : 80, xl: 100 },
          "& .MuiSlider-markLabel": {
            marginTop: -1.2,
            fontSize: 12,
            userSelect: "none",
          },
        }}
        valueLabelFormat={(value) => t(discreteDescriptions[value])}
        valueLabelDisplay="auto"
        value={value}
        disabled={disabled}
        step={shortVersion ? 25 : 1}
        marks={shortVersion ? shortVersionMarks : marks}
        min={0}
        max={shortVersion ? 100 : 4}
        onChange={onChange}
      />
    </Box>
  );
}
